module.exports = __webpack_public_path__ + "media/images/new_home/black-icon-c1520bb1f2e17d573cecc83aaec665d7.png";